import { Instagram } from 'lucide-react';
import { Reveal } from '@/components/Reveal';
import { useSiteConfig } from '@/context/SiteConfigContext';
import { INSTAGRAM_STRIP_IMAGES } from '@/lib/siteImages';

// NOTE: Static curated grid linking out to the real Instagram profile.
// This is NOT a live-syncing feed (would require Instagram Graph API + app
// review). Swap the images or wire up a live feed later if desired.
export const InstagramStrip = () => {
  const config = useSiteConfig();

  return (
    <section className="bg-[#0A0A0A] border-t border-[hsl(var(--lxra-border))]" data-testid="instagram-strip-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 py-16 lg:py-20">
        <Reveal>
          <div className="flex items-center justify-between flex-wrap gap-4 mb-8">
            <div className="flex items-center gap-3">
              <Instagram className="h-5 w-5 text-[hsl(var(--lxra-gold))]" />
              <h2 className="font-display text-2xl sm:text-3xl tracking-[0.04em] text-[hsl(var(--lxra-fg))]">FOLLOW THE STORY</h2>
            </div>
            <a
              href={config.instagram_url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="instagram-strip-handle-link"
              className="text-xs sm:text-sm uppercase tracking-[0.12em] text-[hsl(var(--lxra-fg))] hover:text-[hsl(var(--lxra-gold))] transition-colors"
            >
              {config.instagram_handle}
            </a>
          </div>
        </Reveal>
        <div className="grid grid-cols-3 sm:grid-cols-6 gap-3 sm:gap-4">
          {INSTAGRAM_STRIP_IMAGES.map((src, i) => (
            <Reveal key={src} delay={i * 0.04}>
              <a
                href={config.instagram_url}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative block aspect-square overflow-hidden rounded-lg border border-[hsl(var(--lxra-border))]"
                data-testid={`instagram-strip-image-${i}`}
              >
                <img src={src} alt="LXRA Studios on Instagram" loading="lazy" className="h-full w-full object-cover hover-zoom-img" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-300 flex items-center justify-center">
                  <Instagram className="h-5 w-5 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
